import { generateKey } from '@kineticdata/react';
import { C } from '@kineticdata/bundle-common';
import { Map, OrderedMap } from 'immutable';

const DEFAULT_CONTENT_OUTLINE_PORTFOLIO = {
  Settings: { rendererId: 'PORTFOLIO_SETTINGS', settings: true },
  'Available Services': { rendererId: 'PORTFOLIO_SERVICES' },
  Description: {},
  'Portfolio Management Team': { rendererId: 'PORTFOLIO_MANAGEMENT' },
  Roadmap: {},
  References: {},
  RASCI: {},
};

const DEFAULT_CONTENT_OUTLINE_SERVICE = {
  Settings: { rendererId: 'SERVICE_SETTINGS', settings: true },
  'Service Offerings': { rendererId: 'SERVICE_OFFERINGS' },
  Description: {},
  'Included Components': {},
  Options: {},
  'Costs and Pricing': { rendererId: 'SERVICE_COSTS' },
  'Service Dependencies': { rendererId: 'SERVICE_DEPENDENCIES' },
  'Planned Changes': {},
  'Service Management Team': { rendererId: 'SERVICE_MANAGEMENT' },
  'Current Customers': {},
  'Technical Appendices': { rendererId: 'SERVICE_APPENDICES' },
  'Additional Information': {},
  'ITILv4 - Service Management Practices': {
    children: {
      'Availability Management': {},
      'Capacity & Performance Management': {},
      'Change Enablement': {
        children: {
          'Business Change Management': {},
          'Technical Change Management': {},
        },
      },
      'Incident Management': {},
      'IT Asset Management': {},
      'Monitoring and Event Management': {},
      'Service Desk Management': {},
      'Service Level Management': {},
      'Service Request Management': {},
      'Problem Management': {},
      'Release Management': {},
      'Service Catalog Management': {},
      'Service Continuity Management': {},
    },
  },
  'ITILv4 - Technical Management Practices': {
    children: {
      'Deployment Management': {},
      'Infrastructure & Platform Management': {},
      'Software Development & Management': {},
    },
  },
  'ITILv4 - General Management Practices': {
    children: {
      'Architectural Management': {},
      'Continual Improvement': {},
      'Information Security Management': {},
      'Knowledge Management': {},
      'Measurement & Reporting Management': {},
      'Project Management': {},
      'Service Financial Management': {},
      'Relationship Management': {},
      'Risk Management': {},
      'Portfolio Management': {},
      'Strategy Management': {},
      'Supplier Management': {},
    },
  },
};

const DEFAULT_CONTENT_OUTLINE_APPENDIX = {
  Settings: { rendererId: 'APPENDIX_SETTINGS', settings: true },
  Introduction: {},
  'Service Definition': {},
  Dependencies: {},
  'Service Attributes': {},
  'Roles and Responsibilities': {},
  'Service Delivery': {},
};

const DEFAULT_CONTENT_OUTLINE = {
  Description: {},
};

const buildContentJSONFromOutline = (outline, updatedAt, parentId = null) =>
  OrderedMap(outline).reduce((content, { children, ...data }, title) => {
    const id = generateKey(8);
    const descendants = !!children
      ? buildContentJSONFromOutline(children, updatedAt, id)
      : [];
    return [
      ...content,
      { title, id, parentId, ...data, updatedAt },
      ...descendants,
    ];
  }, []);

export const getDefaultContent = (type = C.FORM_SLUG_SERVICE) => {
  const outline =
    type === C.FORM_SLUG_SERVICE
      ? DEFAULT_CONTENT_OUTLINE_SERVICE
      : type === C.FORM_SLUG_PORTFOLIO
        ? DEFAULT_CONTENT_OUTLINE_PORTFOLIO
        : type === C.FORM_SLUG_APPENDIX
          ? DEFAULT_CONTENT_OUTLINE_APPENDIX
          : DEFAULT_CONTENT_OUTLINE;
  const updatedAt = new Date().toISOString();
  return JSON.stringify(buildContentJSONFromOutline(outline, updatedAt));
};

// Get any settings sections that are required in case the data was manipulated
export const getRequiredDefaultContentArray = (type = 'service') => {
  const outline =
    type === C.FORM_SLUG_SERVICE
      ? DEFAULT_CONTENT_OUTLINE_SERVICE
      : type === C.FORM_SLUG_PORTFOLIO
        ? DEFAULT_CONTENT_OUTLINE_PORTFOLIO
        : type === C.FORM_SLUG_APPENDIX
          ? DEFAULT_CONTENT_OUTLINE_APPENDIX
          : DEFAULT_CONTENT_OUTLINE;
  const updatedAt = new Date().toISOString();
  return buildContentJSONFromOutline(
    Map(outline)
      .filter(v => !!v.settings)
      .toJS(),
    updatedAt,
  );
};
